// ToastNotifier.js

import React from "react";
import { toast, ToastContainer } from "react-toastify";
import { FaTimes } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";

// Import custom icons - update paths if necessary
import errorIcon from "../../../Assests/Images/close.png";
import successIcon from "../../../Assests/Images/check.png";

// ToastContainer component with global settings
const ToastNotifier = () => (
  <ToastContainer
    position="top-right"
    autoClose={3000}
    hideProgressBar
    theme="colored"
  />
);

// showToast function to display custom styled toasts
export const showToast = (type, message) => {
  const config = {
    icon:
      type === "error" ? (
        <div  className={"error_toast"} style={{ backgroundColor: "#fff", padding: "5px",borderRadius:"8px",marginRight:'10px' }}>
          <img
            src={errorIcon}
            alt="Error"
            style={{ width: 15, height: 15, }}
          />
        </div>
      ) : type === "success" ? (
        <div className={"success_toast"} style={{ backgroundColor: "#fff", padding: "5px",borderRadius:"8px",marginRight:'10px' }}>
          <img
            src={successIcon}
            alt="Success"
            style={{ width: 20, height: 20, }}
          />
        </div>
      ) : null,
    // closeButton: <CustomCloseButton />, // Ensures each toast has custom close button
    className: type === "error" ? "error_toast" : "success_toast", // Custom class for styling
    closeOnClick: true,
    autoClose: 5000,
  };

  // Display toast based on type
  if (type === "error") {
    toast.error(message, config);
  } else if (type === "success") {
    toast.success(message, config);
  } else {
    toast.info(message, config);
  }
};

export default ToastNotifier;
